export default __webpack_public_path__ + "static/media/howsell-1.02d723f2.svg";